<script>
  // A styled button that works as a link
  export let href = '';
  export let variant = 'primary'; // primary, secondary, or outline
  export let size = 'md'; // sm, md, lg
</script>

<a {href} class="{getVariantClasses(variant)} {getSizeClasses(size)} rounded font-medium transition-colors inline-block text-center">
  <slot>Button</slot>
</a>

<script context="module">
  function getVariantClasses(variant) {
    switch (variant) {
      case 'primary':
        return 'bg-blue-600 hover:bg-blue-700 text-white';
      case 'secondary':
        return 'bg-gray-600 hover:bg-gray-700 text-white';
      case 'outline':
        return 'border border-blue-600 text-blue-600 hover:bg-blue-50';
      default:
        return 'bg-blue-600 hover:bg-blue-700 text-white';
    }
  }
  
  function getSizeClasses(size) {
    switch (size) {
      case 'sm':
        return 'px-3 py-1.5 text-sm';
      case 'md':
        return 'px-4 py-2 text-base';
      case 'lg':
        return 'px-6 py-3 text-lg';
      default:
        return 'px-4 py-2 text-base';
    }
  }
</script>
